import { useFormikContext } from 'formik'
import { FC } from 'react'

import { getCurrencySymbol } from '@utils/transaction.utils'

import { CurrencyType } from '@model/WalletDto'

import { createFormCurrencyAmountField } from '@global/formField/CurrencyAmountRateField'

import { DepositFormValues } from '../DepositFlowLayout/types'
import { DepositTarget } from '../hooks/types'
import { getDestinationCurrencyId } from './helpers'

const FormCurrencyAmountField = createFormCurrencyAmountField()

export const MAX_ALLOWED_AMOUNT_SAFETY_CAP = 1_000_000_000_000_000

export const DepositAmountField: FC<{
  target?: DepositTarget
  autoFocus?: boolean
  onBlur?: () => void
}> = ({ target, onBlur }) => {
  const { values } = useFormikContext<DepositFormValues>()

  const destinationCurrencyId = getDestinationCurrencyId({ target, values })
  const providerCurrencyId = values?.paymentProvider?.currency?.id || ''

  const symbol = getCurrencySymbol((providerCurrencyId || destinationCurrencyId) as CurrencyType)

  return (
    <FormCurrencyAmountField
      name='amount'
      label={undefined}
      placeholder={undefined}
      fromCurrency={providerCurrencyId}
      toCurrency={destinationCurrencyId}
      leftText={symbol}
      max={MAX_ALLOWED_AMOUNT_SAFETY_CAP}
      fullWidth
      required
      onBlur={onBlur}
    />
  )
}
